
import { REF_CODE_METADATA } from './ref-code.metadata';
import { RefCodeBase, RefCodeKeyBase } from './ref-code.model.base';
import { CrudEntity, CrudEntityConstructionOptions, PropertyChangeEvent, PropertyMetadata } from '@scisys-uim/uim-common';

export interface RefCode extends RefCodeBase {
}
export interface RefCodeKey extends RefCodeKeyBase {
}

export interface RefCodeTransient { }

export class RefCode extends CrudEntity<RefCode, RefCodeKey, RefCodeTransient> implements RefCodeTransient {
  constructor(source?: Partial<RefCode>, options?: CrudEntityConstructionOptions<RefCode, RefCodeKey, RefCodeTransient>) {
    super(REF_CODE_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  changeOwnProperty(event: PropertyChangeEvent<any, any>, propertyMetadata?: PropertyMetadata): void {
    if (event.property == "domain") {
      if (event.newValue != null && typeof event.newValue == 'string') {
        this.domain = (<string>event.newValue).toUpperCase()
      }
    }
  }

  get val1String(): string | null {
    return this.val1;
  }

  get val2String(): string | null {
    return this.val2;
  }

  get val1Bool(): boolean | null {
    return this.valToBool(this.val1);
  }

  get val2Bool(): boolean | null {
    return this.valToBool(this.val2);
  }

  get val1Num(): number | null {
    return this.valToNum(this.val1);
  }

  get val2Num(): number | null {
    return this.valToNum(this.val2);
  }

  private valToBool(str: string): boolean | null {
    if (str.toLowerCase() === 'true') {
      return true;
    } else if (str.toLowerCase() === 'false') {
      return false;
    } else {
      return null;
    }
  }

  private valToNum(str: string): number | null {
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  }

}





